module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "efficiency-graph"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('graph-card', {
    attrs: {
      "heading": "Hvor meget tid bruger svendene hos kunderne?",
      "unit": "%",
      "ylabel": "Timer brugt på kundeopgaver",
      "height": "450",
      "trend": true,
      "endpoint": _vm.efficiencyGraph,
      "paramsInEndpoint": _vm.efficiencyGraphParams,
      "series": _vm.efficiencyGraphSeries
    }
  }, [_c('button', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0",
      "line-height": "50px",
      "margin-right": "15px",
      "outline": "none"
    },
    on: {
      "click": function($event) {
        return _vm.toggleEfficiency()
      }
    }
  }, [(_vm.efficiencyGraph === 'efficiency') ? _c('span', [_vm._v("\n                Vis fordeling pr. ugedag\n            ")]) : (_vm.efficiencyGraph === 'efficiency?weekdays=1') ? _c('span', [_vm._v("\n                Vis fordeling pr. måned\n            ")]) : _vm._e()])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c838013"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/employees/learning/efficiencyGraph.vue
// module id = 892
// module chunks = 0